import React from 'react';
/**
 *
 * Text Over Image Thumb component
 * @extends {React.Component}
 */
interface IProps {
  text?: string;
  image?: string;
  verticalPosition?: string;
  horizontalPosition?: string;
  link?:string;
  backgroundTint?:string;
}

class TextOverImageThumb extends React.Component<IProps>{
  public render(): JSX.Element {
    let verticalPositionClass = this.props.verticalPosition ?  "vertical-"+this.props.verticalPosition : "vertical-center";
    let horizontalPositionClass = this.props.horizontalPosition ?  "horizontal-"+this.props.horizontalPosition : "horizontal-center";
    let backgroundTintClass = this.props.backgroundTint == "dark" ? 'dark' : 'light';
    let item =
      <div className={"text-over-image-thumb"}>
        {this.props.text && <div className={"text-over-image-thumb-text "+verticalPositionClass+" "+horizontalPositionClass}><h4 className="text-over-image-thumb-text-content">{this.props.text}</h4></div>}
        <div className={"hover-overlay"}></div>
        <div className={"tint "+backgroundTintClass}></div>
        {this.props.image && <div className="text-over-image-thumb-background" style={{backgroundImage:"url("+this.props.image+")"}}></div>}
      </div>
    if(this.props.link){
      return <a className="link-reset" href={this.props.link}>{item}</a>
    } else{
      return item
    }
  }
}

export default TextOverImageThumb;
